import React from 'react';

import {
  StoreBadgeContainer,
  StoreBadgeLink,
  QRCodeWrapper,
  QRCode,
} from './AppDownloadLinks.styles';

import AppStoreBadge from '@/assets/AppStore.svg';
import GooglePlayBadge from '@/assets/GooglePlay.svg';
import {
  DAYLIGHT_APP_STORE_URL,
  DAYLIGHT_GOOGLE_PLAY_URL,
  DAYLIGHT_SMART_LINK_URL,
  SLEEPIO_APP_STORE_URL,
  SLEEPIO_GOOGLE_PLAY_URL,
  SLEEPIO_SMART_LINK_URL,
} from '@/pages/Onboarding/utils/constants';
import { getPlatform } from '@/pages/Onboarding/utils/platformHelpers';
import { Platform, Product } from '@/utils/productHelpers';

type Props = {
  product: Product;
};

const APP_LINKS: Record<string, {
  appStore: string;
  googlePlay: string;
  qrCode: string;
}> = {
  daylight: {
    appStore: DAYLIGHT_APP_STORE_URL,
    googlePlay: DAYLIGHT_GOOGLE_PLAY_URL,
    qrCode: DAYLIGHT_SMART_LINK_URL,
  },
  sleepio: {
    appStore: SLEEPIO_APP_STORE_URL,
    googlePlay: SLEEPIO_GOOGLE_PLAY_URL,
    qrCode: SLEEPIO_SMART_LINK_URL,
  },
};

// Store badge on mobile, QR code on web, for the app matching the product.
const AppDownloadLinks: React.FC<Props> = ({ product }) => {
  const platform = getPlatform();
  const links = APP_LINKS[product] ?? APP_LINKS.sleepio;

  if (platform === Platform.iOS) {
    return (
      <StoreBadgeContainer>
        <StoreBadgeLink
          href={links.appStore}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="app-store-link"
        >
          <img src={AppStoreBadge} alt="Download on the App Store" />
        </StoreBadgeLink>
      </StoreBadgeContainer>
    );
  }

  if (platform === Platform.Android) {
    return (
      <StoreBadgeContainer>
        <StoreBadgeLink
          href={links.googlePlay}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-play-link"
        >
          <img src={GooglePlayBadge} alt="Get it on Google Play" />
        </StoreBadgeLink>
      </StoreBadgeContainer>
    );
  }

  return (
    <QRCodeWrapper>
      <QRCode
        data-testid="qr-code"
        value={links.qrCode}
      />
    </QRCodeWrapper>
  );
};

export default AppDownloadLinks;
